import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dFunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
const NothingLast = x => x;
const withIndex = xs => Data$dArray.zipWithImpl(Data$dTuple.Tuple, Data$dArray.rangeImpl(0, xs.length), xs);
const traverseMaybes = dictApplicative => {
  const map1 = dictApplicative.Apply0().Functor0().map;
  const traverse1 = Data$dTraversable.traversableArray.traverse(dictApplicative);
  return f => arr => map1(Data$dArray.catMaybes)(traverse1(f)(arr));
};
const stableSortWith = dictOrd => {
  const sortWith = Data$dArray.sortWith(Data$dTuple.ordTuple(dictOrd)(Data$dOrd.ordInt));
  return keyFn => {
    const $0 = Data$dFunctor.arrayMap(Data$dTuple.snd);
    const $1 = sortWith(v => Data$dTuple.$Tuple(keyFn(v._2), v._1));
    const $2 = Data$dFunctorWithIndex.mapWithIndexArray(Data$dTuple.Tuple);
    return x => $0($1($2(x)));
  };
};
const partitionMap = f => arr => Data$dFoldable.foldlArray(v => {
  const $0 = v.lefts;
  const $1 = v.rights;
  return item => {
    const v1 = f(item);
    if (v1.tag === "Right") { return {lefts: $0, rights: Data$dSemigroup.concatArray([v1._1])($1)}; }
    if (v1.tag === "Left") { return {lefts: Data$dSemigroup.concatArray([v1._1])($0), rights: $1}; }
    $runtime.fail();
  };
})({lefts: [], rights: []})(arr);
const partitionA = dictApplicative => {
  const map1 = dictApplicative.Apply0().Functor0().map;
  const traverse1 = Data$dTraversable.traversableArray.traverse(dictApplicative);
  return p => arr => map1(v => {
    const v1 = Data$dArray.partitionImpl(Data$dTuple.snd, v);
    return {yes: Data$dFunctor.arrayMap(Data$dTuple.fst)(v1.yes), no: Data$dFunctor.arrayMap(Data$dTuple.fst)(v1.no)};
  })(traverse1(x => map1(Data$dTuple.Tuple(x))(p(x)))(arr));
};
const newtypeNothingLast = {Coercible0: () => {}};
const findNWithLargest = dictFoldable => dictOrd => sortKeyFn => n => f => Data$dArray.reverse(dictFoldable.foldr(x => list => {
  const insertSorted = elem => acc => {
    const v = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, acc, 0);
    if (v.tag === "Nothing") { return [elem]; }
    if (v.tag === "Just") {
      if (dictOrd.compare(sortKeyFn(elem))(sortKeyFn(v._1)).tag === "LT") { return Data$dSemigroup.concatArray([elem])(acc); }
      return Data$dSemigroup.concatArray([v._1])(insertSorted(elem)((() => {
        const $0 = Data$dArray.unconsImpl(v$1 => Data$dMaybe.Nothing, v$1 => xs => Data$dMaybe.$Maybe("Just", xs), acc);
        if ($0.tag === "Nothing") { return []; }
        if ($0.tag === "Just") { return $0._1; }
        $runtime.fail();
      })()));
    }
    $runtime.fail();
  };
  if (list.length < n) { return insertSorted(x)(list); }
  const $0 = insertSorted(x)(list);
  return Data$dArray.sliceImpl(1, $0.length, $0);
})([])(f));
const eqNothingLast = dictEq => (
  {
    eq: x => y => {
      if (x.tag === "Nothing") { return y.tag === "Nothing"; }
      if (x.tag === "Just") {
        if (y.tag === "Just") { return dictEq.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  }
);
const ordNothingLast = dictOrd => {
  const $0 = dictOrd.Eq0();
  const eqNothingLast1 = {
    eq: x => y => {
      if (x.tag === "Nothing") { return y.tag === "Nothing"; }
      if (x.tag === "Just") {
        if (y.tag === "Just") { return $0.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  };
  return {
    compare: x => y => {
      if (x.tag === "Just") {
        if (y.tag === "Just") { return dictOrd.compare(x._1)(y._1); }
        if (y.tag === "Nothing") { return Data$dOrdering.LT; }
        $runtime.fail();
      }
      if (x.tag === "Nothing") {
        if (y.tag === "Nothing") { return Data$dOrdering.EQ; }
        return Data$dOrdering.GT;
      }
      $runtime.fail();
    },
    Eq0: () => eqNothingLast1
  };
};
const stableSortWith1 = /* #__PURE__ */ stableSortWith(/* #__PURE__ */ ordNothingLast(Data$dOrd.ordInt));
const restoreOrderWith = dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return keyFn => order => {
    const orderMap = fromFoldable(Data$dFunctorWithIndex.mapWithIndexArray(i => x => Data$dTuple.$Tuple(x, i))(order));
    return stableSortWith1(x => Data$dMap$dInternal.lookup(dictOrd)(keyFn(x))(orderMap));
  };
};
export {
  NothingLast,
  eqNothingLast,
  findNWithLargest,
  newtypeNothingLast,
  ordNothingLast,
  partitionA,
  partitionMap,
  restoreOrderWith,
  stableSortWith,
  stableSortWith1,
  traverseMaybes,
  withIndex
};
